import { GetProceduresRecommendations } from 'domain/usecases/surgical-order-recommendation/get-procedures-recommendations'
import { SurgicalOrderRecommendationRepository } from 'repository/repositories/surgical-order-recommendation/surgical-order-recommendation-repository'

export class RemoteGetProceduresRecommendations
  implements GetProceduresRecommendations
{
  constructor(
    private readonly surgicalOrderRecommendationRepository: SurgicalOrderRecommendationRepository
  ) {}

  get(
    params: GetProceduresRecommendations.Params
  ): Promise<GetProceduresRecommendations.Model> {
    return this.surgicalOrderRecommendationRepository.getProceduresRecommendations(
      params
    )
  }
}
